export default {"src":"/_next/static/media/national-park.f344537c.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};